<template>
  <time v-if="ms !== null" class="local-time" :datetime="datetime">{{ text }}</time>
  <span v-else class="local-time local-time--empty">{{ fallback }}</span>
</template>

<script setup lang="ts">
/**
 * 时刻展示（设备本地时区，规范 6.2）：页面不许自己格式化时间，一律用它。
 * - value：接口时刻串（2026-09-28T02:30:00.000Z），缺席 / 不合法显示 fallback（dev 下 console.error）；
 * - mode：smart 列表智能格式（今天 22:30 / 昨天 / 09-25 22:30 / 跨年全日期，英文 Today / Sep 25, 22:30）、
 *   detail 详情 2026-09-27 22:30:15、datetime 到分钟、date 日期、clock 时分秒、hm 时分；
 * - SSR：没有设备时区 cookie 时只输出 <time datetime> 与占位，挂载后填入；有 cookie 时按它渲染，与水合一致。
 */
import { formatInstant, parseInstant } from '~/utils/time'
import type { LocalTimeMode } from '~/composables/useTimeDisplay'

const props = withDefaults(
  defineProps<{
    value?: string | null
    mode?: LocalTimeMode
    fallback?: string
  }>(),
  { value: null, mode: 'smart', fallback: '—' },
)

const { format } = useTimeDisplay()

const ms = computed(() => parseInstant(props.value))
const datetime = computed(() => (ms.value === null ? undefined : formatInstant(ms.value)))
// 服务端首访没有设备时区：不按服务器时区格式化，输出不换行空格占位
const text = computed(() => (ms.value === null ? '' : (format(ms.value, props.mode) ?? ' ')))
</script>

<style scoped>
.local-time {
  font-variant-numeric: tabular-nums;
}
</style>
